<template>
<div class="ActivityList  bgc padding-20">
    <div class="filters">
        <div class="add">
            <el-button v-if="permission.btnList.indexOf('A020401')==-1" type="primary" @click="handleAdd">新增文章</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list bgc">
        <el-table :data="tableData" style="width: 100%;">
            <el-table-column label="文章名称" fixed class-name="left" width="400">
                <template slot-scope="scope">
                    <div class="nameBox">
                        {{scope.row.title}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="阅读量"  class-name="center">
                <template slot-scope="scope">{{scope.row.viewcount}}</template>
            </el-table-column>
            <el-table-column label="发布时间"  class-name="center">
                <template slot-scope="scope">{{scope.row.datetime}}</template>
            </el-table-column>
            <el-table-column label="发布状态"  class-name="center">
                <template slot-scope="scope">{{scope.row.statusname}}</template>
            </el-table-column>
            <el-table-column label="操作" class-name="right">
                <template slot-scope="scope">
                    <div class="tr">
                        <span v-if="scope.row.status === 1">
                            <el-button @click="changeStatus(scope.row)" type="text" size="small">删除</el-button>
                            <i class="separator">|</i>
                        </span>
                        <span v-else>
                            <el-button @click="changeStatus(scope.row)" type="text" size="small">恢复</el-button>
                            <i class="separator">|</i>
                        </span>
                        <span>
                            <el-button @click="handleShare(scope.row)" type="text" size="small">分享</el-button>
                            <i class="separator">|</i>
                        </span>
                        <span>
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
    <el-dialog title="链接查看" :visible.sync="dialogVisible" @close="cancel">
        <div class="share">
            <div class="box">
                <img :src="item.eventshareurlImg" :alt="item.title">
                <div class="pr-code-text cursor" @click="download(item.eventshareurlImg, item.title)">下载<span class="tc-blue blod">文章</span>二维码</div>
                <el-input v-model.trim="item.eventshareurl" placeholder="" disabled></el-input>
                <el-button  type="primary" size="mini" v-clipboard:copy="item.eventshareurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
            </div>
            <!-- <div class="box">
                <img :src="item.rankshareurlImg" :alt="item.title">
                <div class="pr-code-text cursor" @click="download(item.rankshareurlImg, item.title)">下载<span class="tc-blue blod">活动排行榜</span>二维码</div>
                <el-input v-model.trim="item.rankshareurl" placeholder="" disabled></el-input>
                <el-button  type="primary" size="mini" v-clipboard:copy="item.rankshareurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
            </div> -->
        </div>
    </el-dialog>
</div>
</template>

<script>
import {checkModule} from '@/api/api'
import {getArticleList, updateDisEventArticleStatus} from 'api/nationalDistribution'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {nationalDistribution as nationalDistributionCode} from 'api/enumCode'
import Share from '@/base/share/share'
import {nationalDistribution} from 'api/message'
import {urlToQRCode, downloadImage} from 'common/js/tools'
export default {
    name: 'ArticleList',
    data() {
        return {
            logo: require('@/common/images/index/logo.png'),
            imgNoimg: require('@/common/images/nationalDistributionMenu/img-noimg.png'),
            templatetypeList: nationalDistributionCode.templatetype,
            distypeList: nationalDistributionCode.distype,
            statusList: nationalDistributionCode.activityStatus,
            resulttypeList: nationalDistributionCode.resulttype,
            item: {
                title: '',
                eventshareurl: '',
                rankshareurl: '',
                eventshareurlImg: '',
                rankshareurlImg: ''
            },
            dialogVisible: false,
            total: 0,
            tableData: [],
            power: [],
            rules: {},
            param: {
                eventinnerid: this.$route.query.eventinnerid
            },
        }
    },
    mounted() {
        this.power = this.permission.btnObj.A0204 ? this.permission.btnObj.A0204 : []
        this._getList()
    },
    beforeRouteEnter (to, from, next) {
        next(v => {
            if (v.$route.query.refresh === '1') {
                v.$refs.page.pagination.page = 1
                let page = {
                    page: 1,
                    pageSize: 10
                }
                v.setPage(page)
                v._getList()
            } else if (v.$route.query.refresh === '0') {
                v._getList()
            }
        })
    },
    methods: {
        cancel() {
            this.dialogVisible = false
            this.item = {
                title: '',
                eventshareurl: '',
                rankshareurl: '',
                eventshareurlImg: '',
                rankshareurlImg: ''
            }
        },
        // 改变状态
        changeStatus(row) {
            console.log(row)
            this.setLoading(true)
            let status = row.status === 1 ? 0 : 1
            updateDisEventArticleStatus({
                data: {articleinnerid: row.innerid, eventinnerid: this.$route.query.eventinnerid, status},
                success: data => {
                    this.setLoading(false)
                    this.tableData.some(obj => {
                        if (obj.innerid === row.innerid) {
                            if (status) {
                                obj.statusname = '有效'
                            } else {
                                obj.statusname = '无效'
                            }
                            obj.status = status
                            return false
                        }
                    })
                },
                erros: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleShare(row) {
            this.item.title = row.title
            this.item.eventshareurl = row.shareurl
            // this.item.rankshareurl = row.rankshareurl
            this.item.eventshareurlImg = urlToQRCode(row.shareurl)
            // this.item.rankshareurlImg = urlToQRCode(row.rankshareurl)
            this.dialogVisible = true
        },
        handleWithdrawal (row) {
            this.$router.push({name: 'NDActivityWithdrawal', query: {id: row.innerid, title: row.title}})
        },
        handleToOrder (row) {
            this.$router.push({name: 'NDActivityOrder', query: {id: row.innerid, title: row.title}})
        },
        handleToUser (row) {
            this.$router.push({name: 'NDActivityUser', query: {id: row.innerid, title: row.title}})
        },
        // 新增活动
        handleAdd() {
            var params = {
                moduleid: 'A22'
            }
            checkModule({
                data: Object.assign({}, params),
                success: data => {
                    this.$router.push({name: 'NDArticleEdit', query: {eventinnerid: this.$route.query.eventinnerid}})
                },
                error: data => {
                    console.log('error：', data)
                    this.$message.error(data.msg)
                }
            })
        },
        // 编辑活动
        handleEdit(row) {
            this.$router.push({name: 'NDArticleEdit', query: {eventinnerid: this.$route.query.eventinnerid, articleinnerid: row.innerid}})
        },
        handleClose(row) {
            let status = 11
            this.$confirm(nationalDistribution.close.msg, nationalDistribution.close.title, {
                confirmButtonText: nationalDistribution.close.confirmText,
                cancelButtonText: nationalDistribution.close.cancelText
            }).then(() => {
                this._editStatus(row.innerid, status, nationalDistribution.close.successMsg)
            }).catch(() => {})
        },
        handleOpen(row) {
            let status = 10
            this.$confirm(nationalDistribution.open.msg, nationalDistribution.open.title, {
                confirmButtonText: nationalDistribution.open.confirmText,
                cancelButtonText: nationalDistribution.open.cancelText
            }).then(() => {
                this._editStatus(row.innerid, status, nationalDistribution.open.successMsg)
            }).catch(() => {})
        },
        download(imgsrc, name) { // 下载图片地址和图片名
            downloadImage(imgsrc, name)
        },
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        onError(e) {
            alert('失败')
        },
        _editStatus(innerid, status, tip) {
            this.setLoading(true)
            editDisEventStatus({
                data: {innerid: innerid, status: status},
                success: data => {
                    this.$message.success(tip)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            console.log(this.page)
            getArticleList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    data.data.content.forEach((obj, index) => {
                        obj.sortNum = (this.$refs.page.page.page - 1) * 10 + index + 1
                    })
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams',
            'setPage'
        ])
    },
    filters: {
    },
    watch: {},
    computed: {
        ...mapGetters([
            'page',
            'user',
            'permission',
            'params'
        ])
    },
    components: {
        Page, Share
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.el-message-box__content {
    padding: 30px 50px!important;
    text-align: center!important;
    color: #F56C6C!important;
}
.el-message-box__btns {
    text-align: center!important;
    .el-button {
        margin-bottom: 30px!important;
    }
}
.ActivityList {
    .filters{
        .el-input input{
            width: 180px;
        }
        .el-select .el-input input{
            width: 108px;
        }
    }
    .share{
        @include flexBox(space-around);
        .box{
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            .el-input{
                margin: 10px 0;
            }
        }
        .box+.box{
            margin-left: 20px;
        }
    }
    .result-list{
        .el-table__row{
            height: 100px;
        }
        .el-table__body, .el-table__header{
            width: 100% !important;
        }
        .left{
            .cell{
                text-align: left;
                font-weight: 600;
                .nameBox{
                    // display: flex;
                    font-size: 14px;
                    line-height: 20px;
                    // text-overflow: -o-ellipsis-lastline;
                    // overflow: hidden;
                    // text-overflow: ellipsis;
                    // display: -webkit-box;
                    // -webkit-line-clamp: 2;
                    // line-clamp: 2;
                    // -webkit-box-orient: vertical;
                    .iconBox{
                        width: 106px;
                        height: 60px;
                        margin-right: 10px;
                        img{
                            min-width: 106px;
                            height: 60px;
                        }
                    }
                    .rightBox{
                        min-width: 104px;
                        display: flex;
                        flex-direction: column;
                        .title{
                            height: 40px;
                            line-height: 20px;
                            overflow: hidden;
                            .text{
                                font-weight: 600;
                                float: right;
                                /* "margin-left"要等于".wrap::before"的宽度 */
                                margin-left: -10px;
                                width: 100%;
                                word-break: break-all;
                                text-align: left;
                                font-size: 14px;
                                // font-size: 0.48rem;
                            }
                            &::before {
                                float: left;
                                content: '';
                                width: 10px;
                                height: 100%;
                            }
                            &::after {
                                float: right;
                                content: "...";
                                /* 行高与".wrap"设置的一致即可 */
                                height: 40px;
                                line-height: 20px;
                                /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                                width: 37px;
                                margin-left: -37px;
                                /* 移动省略号位置 */
                                position: relative;
                                left: 101.9%;
                                bottom: 20px;
                                font-weight: 600;
                                padding-right: 1px;
                                background: #fff;
                                transition: all 0.5s;
                                text-align: left;
                            }
                        }
                        .tip{
                            font-size: 12px;
                            span+span{
                                margin-left: 10px;
                            }
                        }
                        .type{
                            text-align: left;
                        }
                        .type1{
                            color: #67C23A;
                        }
                        .type2{
                            color: #409EFF;
                        }
                        .type3{
                            color: #E6A23C;
                        }
                        .type4{
                            color:  #F56C6C;
                        }
                    }
                }
            }
        }
        .right{
            .cell{
                text-align: right;
            }
        }
        .center{
            .cell{
                text-align: center;
                padding: 0;
                .nameBox{
                    display: flex;
                    .iconBox{
                        width: 106px;
                        height: 60px;
                        margin-right: 10px;
                        img{
                            min-width: 106px;
                            height: 60px;
                        }
                    }
                }
                .ing{
                    color: #67C23A;
                }
            }
        }
        .el-table__row:hover{
            .left{
                .cell{
                    .title{
                        &::after{
                            background: #F5F7FA;
                        }
                    }
                }
            }
        }
        .imageText{
            .imageText-summary{
                margin-left: 5px;
                .textBox{
                    width: 345px;
                    height: 40px;
                    line-height: 20px;
                    overflow: hidden;
                    .text{
                        float: right;
                        /* "margin-left"要等于".wrap::before"的宽度 */
                        margin-left: -10px;
                        width: 345px;
                        word-break: break-all;
                        // font-size: 0.48rem;
                    }
                    &::before {
                        float: left;
                        content: '';
                        width: 10px;
                        height: 100%;
                    }
                    &::after {
                        float: right;
                        content: "...";
                        /* 行高与".wrap"设置的一致即可 */
                        height: 40px;
                        line-height: 20px;
                        /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                        width: 37px;
                        margin-left: -37px;
                        /* 移动省略号位置 */
                        position: relative;
                        left: 101.8%;
                        bottom: 20px;
                        font-weight: 600;
                        padding-right: 1px;
                        background: #fff;
                        transition: all 0.5s;
                    }
                    .recommon{
                        color: #fff;
                        background: #E6A23C;
                        display: inline-block;
                        width: 36px;
                        height: 16px;
                        line-height: 16px;
                        text-align: center;
                        margin-right: 5px;
                        font-size: 12px;
                    }
                }
                .price{
                    margin-left: 5px;
                    color: #F56C6C;
                }
            }
        }
        .el-table__row:hover{
            .textBox{
                &::after{
                    background: #F5F7FA;
                }
            }
        }
        img{
            min-width: 100px;
            max-width: 100px;
            height: 60px;
        }
        .icon{
            margin-left: 10px;
            width: 14px;
            height: 14px;
        }
    }
    .result-list .imageText .imageText-summary div:nth-child(1){
        margin-bottom: 0;
    }
    .el-table{
        .title{
            .cell{
                padding: 0;
                margin-left: 5px;
            }
        }
        .center{
            .cell{
                text-align: center;
            }
        }
    }
}
.el-popover{
    .videoList-pr-code-upload{
        text-align: center;
        img{
            width: 160px;
            height: 160px;
        }
        .pr-code-text{
            color: $tcolor-blue;
            padding: 20px 0;
        }
        .btn-operate{
            @include flexBox(space-between);
            .el-input,input{
                width: 210px;
                height: 36px;
                line-height: 36px;
            }
            .el-button{
                min-width: 60px;
            }
        }
    }
}
</style>
